import { useEffect } from 'react';

const waitForElementAndScroll = (selector: string, timeout = 5000, interval = 100) => {
  const startTime = performance.now();
  const intervalId = setInterval(() => {
    const element = document.querySelector(selector);
    if (element) {
      element.scrollIntoView({ block: 'start' });
      clearInterval(intervalId);
      return;
    }

    if (performance.now() - startTime >= timeout) {
      clearInterval(intervalId);
    }
  }, interval);
};

/**
 * Scroll to anchor links when page is loaded and have hash in url and wait for anchor element is ready in DOM
 */
export const ScrollToHashWhenReady = () => {
  useEffect(() => {
    const hash = window.location.hash;
    if (!hash) return;
    waitForElementAndScroll(hash);
  }, []);

  return null;
};
